export const slickDealsShellsLogo = require("./image.png");
